// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"dee3dd836ad7f0cf9aec","873":"d21dc089409efd9fa8a1"}[chunkId] + ".js";
};